<template>
  <v-card
    class="mx-3 mb-5"
    max-width="300"
    dark
  >
    <v-img
        class="white--text align-end"
        height="200px"
        src="https://media3.giphy.com/media/xUOwGnZPpt0P7ZOIxO/giphy.gif?cid=ecf05e47q28pfx26wxwd94ie46gkkozs1foxfqmzn6ex4ps3&rid=giphy.gif&ct=g" 
      >
        <v-card-title text="purple lighten-3">Python Server</v-card-title>
    </v-img>

    <v-card-text>
        <div>BUILT WITH.</div>
        <div div>Python</div>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="purple lighten-3"
        text
        href="https://github.com/rogieBeer/Pub_BirdAPI"
      >
        CODE
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    name: "ProjectCard5"

}
</script>

<style scoped>

</style>